export const SET_DISKS = 'SET_DISKS'
export const SET_DISK_DRIVER = 'SET_DISK_DRIVER'
export const ADD_DISKS = 'ADD_DISKS'
export const DELETE_DISK = 'DELETE_DISK'
